import { createRouter, createWebHistory } from 'vue-router';
import DefaultLayout from '../components/layout/DefaultLayout.vue';
import LoginLayout from '../components/layout/LoginLayout.vue';
import AdminLayout from '../components/layout/AdminLayout.vue';
import { supabase } from '@/API/supabase';
import VueCookies from 'vue-cookies';
import VueJwtDecode from 'vue-jwt-decode';
import store from '@/store';

const routes = [
    // home
    {
        path: '/',
        redirect: '/home',
        meta: {
            title: '홈',
        },
    },

    // 홈
    {
        path: '/home',
        name: 'home',
        component: () => import('../views/main/home'),
        meta: {
            title: 'Home',
            layout: DefaultLayout,
        },
    },

    // 비상벨 알람 현황
    {
        path: '/alarm',
        name: 'alarm',
        component: () => import('../views/alarm/alarm'),
        meta: {
            title: 'alarm',
            layout: DefaultLayout,
        },
    },

    // 장치관리
    {
        path: '/device',
        name: 'device',
        component: () => import('../views/device/device'),
        meta: {
            title: 'device',
            layout: DefaultLayout,
        },
    },

    // 통계데이터
    {
        path: '/statistics',
        name: 'statistics',
        component: () => import('../views/statistics/statistics'),
        meta: {
            title: 'statistics',
            layout: DefaultLayout,
        },
    },

    // 환경설정
    {
        path: '/setting',
        name: 'setting',
        component: () => import('../views/setting/setting'),
        meta: {
            title: 'setting',
            layout: DefaultLayout,
        },
    },

    //로그인
    {
        path: '/login',
        name: 'login',
        component: () => import('../views/account/login'),
        meta: {
            title: '로그인',
            layout: LoginLayout,
        },
    },

    // 아이디 찾기
    {
        path: '/findID',
        name: 'findID',
        component: () => import('../views/account/findID'),
        meta: {
            title: '아이디 찾기',
            layout: LoginLayout,
        },
    },

    // 비밀번호 찾기
    {
        path: '/findPW',
        name: 'findPW',
        component: () => import('../views/account/findPW'),
        meta: {
            title: '비밀번호 찾기',
            layout: LoginLayout,
        },
    },

    // 비밀번호 변경
    {
        path: '/changePW/:token',
        name: 'changePW',
        component: () => import('../views/account/changePW'),
        meta: {
            title: '비밀번호 변경',
            layout: LoginLayout,
        },
    },

    // 관리자 페이지
    {
        path: '/admin',
        name: 'admin',
        component: () => import('../views/admin/admin'),
        meta: {
            title: 'admin',
            layout: AdminLayout,
        },
    },

    // 개인정보처리방침 (syscall)
    {
        path: '/privacy',
        name: 'privacy',
        component: () => import('../views/privacy/privacy'),
        meta: {
            title: '개인정보처리방침',
            layout: LoginLayout,
        },
    },

    // 개인정보처리방침 (ringobell)
    {
        path: '/privacy_ringobell',
        name: 'privacy_ringobell',
        component: () => import('../views/privacy/privacy_ringobell'),
        meta: {
            title: '개인정보처리방침',
            layout: LoginLayout,
        },
    },
];

const router = createRouter({
    // mode: 'history',
    history: createWebHistory(),
    linkActiveClass: 'active',
    //linkExactActiveClass: 'active',
    routes,
    scrollBehavior(to, from, savedPosition) {
        if (savedPosition) {
            return savedPosition;
        } else {
            return { left: 0, top: 0 };
        }
    },
});

router.beforeEach(async (to, from, next) => {
    /*
     * to: 이동할 url 정보가 담긴 라우터 객체
     * from: 현재 url 정보가 담긴 라우터 객체
     * next: to에서 지정한 url로 이동하기 위해 꼭 호출해야 하는 함수
     * next() 가 호출되기 전까지 화면 전환되지 않음
     */

    const token = VueCookies.get('nttworks_access_token');
    const refreshToken = VueCookies.get('nttworks_refresh_token');
    const user_id = VueCookies.get('nttworks_user_id');
    const auth = VueCookies.get('nttworks_auth');

    let isVerified = false;
    let isAutoLogin = false;

    // 1. 토큰 유효성 검사
    if (token !== null && token !== 'null' && token !== undefined) {
        if(token.includes('.')){
            var decoded = decodeJwt(token);
            var payload = decoded.payload;
            var expTime = payload.exp;
            var expireDate = new Date(expTime * 1000);
            var today = new Date();
            if(expireDate > today){
                isVerified = true;
            }

            // ****** 기존 디코딩 방식 - 페이스북 token 디코딩 오류로 인한 변경 (atob 관련 오류) ******
            // let decoded = VueJwtDecode.decode(token)
            // console.log(decoded);
            // var expTime = decoded.exp;
            // var expireDate = new Date(expTime * 1000);
            // var today = new Date();

            // if(expireDate > today){
            //     isVerified = true;
            // }

        }
    }

    // 2. 로그인 페이지로 이동하려는 경우
    if (to.path.includes('login') || to.path.includes('find') || to.path.includes('changePW')) {
        if (isVerified) {
            if (auth == '0' || auth == '1') {
                return next('/admin'); // 관리자 권한이 있는 경우 관리자 페이지로 리디렉션
            } else {
                return next('/home'); // 인증된 경우 홈으로 리디렉션
            }
        } else {
            return next(); // 로그인 페이지 접근 허용
        }
    }else if(to.path.includes('privacy')){
        return next(); // 개인정보처리방침 페이지 접근 허용
    } else {
        if (token !== null) {
            // 토큰이 쿠키에 존재하는 경우

            var userInfo = {
                access_token: VueCookies.get('nttworks_access_token'),
                refresh_token: VueCookies.get('nttworks_refresh_token'),
                user_id: VueCookies.get('nttworks_user_id'),
                autoLogin: VueCookies.get('nttworks_autoLogin'),
                display_name: VueCookies.get('nttworks_display_name'),
                user_name: VueCookies.get('nttworks_user_name'),
                comp_id: VueCookies.get('nttworks_comp_id'),
                auth: VueCookies.get('nttworks_auth'),
                thumb: VueCookies.get('nttworks_thumb'),
                emr_color: VueCookies.get('nttworks_emr_color'),
                stt_color: VueCookies.get('nttworks_stt_color'),
                melody: VueCookies.get('nttworks_melody'),
                sound: VueCookies.get('nttworks_sound'),
                rows_per_page: VueCookies.get('nttworks_rows_per_page'),
            };

            if (isVerified) {
                // token이 인증된 경우
                store.commit('setLoggedIn', true);
                store.commit('resetUserInfo', userInfo);

                if (to.name == 'login') {
                    if (auth == '0' || auth == '1') {
                        return next('/admin'); // 관리자 권한이 있는 경우 관리자 페이지로 리디렉션
                    } else {
                        return next('/'); // 인증된 경우 홈으로 리디렉션
                    }
                } else {
                    // 관리자 페이지로 이동하려는 경우
                    if (to.path.includes('admin')) {
                        if (auth == '0' || auth == '1') {
                            return next(); // 관리자 권한이 있는 경우 접근 허용
                        } else {
                            return next('/home'); // 관리자 권한이 없는 경우 홈으로 리디렉션
                        }
                    } else {
                        if (auth == '0' || auth == '1') {
                            if (to.query.user_id == undefined || to.query.user_id == 'undefined') {
                                return next('/admin'); // user_id 식별자가 없는 경우 관리자 페이지로 리디렉션
                            } else {
                                return next();
                            }
                        } else {
                            return next();
                        }
                    }
                }
            } else {
                // token 인증이 만료된 경우
                isAutoLogin = userInfo.autoLogin;

                if (isAutoLogin == 'true') {
                    // 자동로그인일 경우 'JWT' 재발급
                    if (refreshToken) {
                        async function checkRefreshSession() {
                            try {
                                const refreshSessionInfo = await refreshSession(refreshToken, user_id);

                                if (refreshSessionInfo.success) {
                                    userInfo.access_token = refreshSessionInfo.accessToken;
                                    userInfo.refresh_token = refreshSessionInfo.refreshToken;

                                    //console.log("userInfo: ", userInfo);

                                    store.commit('setLoggedIn', true);
                                    store.commit('setUser', userInfo);

                                    return true; // Indicate success
                                } else {
                                    // 세션 불러오기 실패 시
                                    store.commit('logoutUser');

                                    next('/login');
                                    return false; // Indicate failure
                                }
                            } catch (error) {
                                console.error('error', error.message);
                                store.commit('logoutUser');

                                next('/login');
                                return false;
                            }
                        }
                        const success = await checkRefreshSession();
                        if (success) {
                            //return next();

                            // 관리자 페이지로 이동하려는 경우
                            if (to.path.includes('admin')) {
                                if (auth == '0' || auth == '1') {
                                    return next(); // 관리자 권한이 있는 경우 접근 허용
                                } else {
                                    return next('/home'); // 관리자 권한이 없는 경우 홈으로 리디렉션
                                }
                            } else {
                                if (auth == '0' || auth == '1') {
                                    if (to.query.user_id == undefined || to.query.user_id == 'undefined') {
                                        return next('/admin'); // user_id 식별자가 없는 경우 관리자 페이지로 리디렉션
                                    } else {
                                        return next();
                                    }
                                } else {
                                    return next();
                                }
                            }
                        }
                    } else {
                        store.commit('logoutUser');
                        await logout();
                        //const { error } = supabase.auth.signOut();
                        next('/login');
                    }
                } else {
                    const authRequired = to.path.includes('login') ? false : true;

                    if (!authRequired) {
                        return next();
                    } else {
                        store.commit('logoutUser');

                        next('/login');
                    }
                }
            }
        } else {
            // 토큰이 쿠키에 없는 경우
            store.commit('logoutUser');

            // 로그인 페이지 제외하고는 모두 authRequired = true
            // const authRequired = to.path.includes('login') ? false : true;
            const authRequired = to.path.includes('login') ? false : true;

            if (!authRequired) {
                return next();
            } else {
                next('/login');
            }
        }
    }
});

// refresh token으로 세션 다시 생성하기 -- api 호출
async function refreshSession(refresh_token, user_id) {
    var params = {
        refresh_token: refresh_token,
        user_id: user_id,
    };
    return await store
        .dispatch('UserAccountStore/refreshToken', params)
        .then((res) => {
            // console.log("refreshSession res: ", res);
            //console.log(res);
            if (res.success) {
                return {
                    success: true,
                    accessToken: res.accessToken,
                    refreshToken: res.refreshToken,
                };
            } else {
                return {
                    success: false,
                };
            }
        })
        .catch(({ message }) => {
            alert(message);
            return { success: false };
        });
}

// 로그아웃 -- api 호출
async function logout(user_id) {
    var params = {
        user_id: user_id,
    };
    return await store
        .dispatch('UserAccountStore/logout', params)
        .then((res) => {
            //console.log(res);
            if (res.success) {
                return {
                    success: true,
                };
            } else {
                return {
                    success: false,
                };
            }
        })
        .catch(({ message }) => {
            alert(message);
            return { success: false };
        });
}


function base64UrlDecode(str) {
    // Base64Url에서 표준 Base64로 변환
    let base64 = str.replace(/-/g, "+").replace(/_/g, "/");
    // 패딩 추가 (4의 배수가 되도록)
    while (base64.length % 4 !== 0) {
        base64 += "=";
    }
    return atob(base64);
}

function decodeJwt(token) {
    const parts = token.split(".");
    if (parts.length !== 3) {
        throw new Error("잘못된 JWT 형식입니다.");
    }
    
    const header = JSON.parse(base64UrlDecode(parts[0]));
    const payload = JSON.parse(base64UrlDecode(parts[1]));
    
    return { header, payload };
}


export default router;
